import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const ProjectIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M6.60001 10.7C6.26864 10.7 6.00001 10.9686 6.00001 11.3C6.00001 11.6314 6.26864 11.9 6.60001 11.9H10.6C10.9314 11.9 11.2 11.6314 11.2 11.3C11.2 10.9686 10.9314 10.7 10.6 10.7H6.60001Z"
				fill="#4C4C58"
			/>
			<path
				d="M9.4 13.5C9.4 13.1686 9.66863 12.9 10 12.9H14C14.3314 12.9 14.6 13.1686 14.6 13.5C14.6 13.8314 14.3314 14.1 14 14.1H10C9.66863 14.1 9.4 13.8314 9.4 13.5Z"
				fill="#4C4C58"
			/>
			<path
				d="M13.4 15.1C13.0686 15.1 12.8 15.3686 12.8 15.7C12.8 16.0314 13.0686 16.3 13.4 16.3H17.4C17.7314 16.3 18 16.0314 18 15.7C18 15.3686 17.7314 15.1 17.4 15.1H13.4Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 7V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7ZM19 5.2H5C4.00589 5.2 3.2 6.00589 3.2 7V7.4H20.8V7C20.8 6.00589 19.9941 5.2 19 5.2ZM3.2 17V8.6H20.8V17C20.8 17.9941 19.9941 18.8 19 18.8H5C4.00589 18.8 3.2 17.9941 3.2 17Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

ProjectIcon.propTypes = iconPropTypes;
ProjectIcon.defaultProps = iconDefaultProps;
